import * as themes from '../defs'
import type { Theme } from '../types'

const DEFAULT_THEME = 'blended'

function getTheme(key: string | undefined): Theme | undefined {
  return Object.values(themes).find((theme) => theme.key === key)
}

/**
 * Function to return theme based on its name
 * @param name
 * @returns
 */
export function loadTheme(
  key: string | undefined,
  defaultTheme: string = DEFAULT_THEME, // Dependency injection for testing
): Theme {
  const theme = getTheme(key) || getTheme(defaultTheme)!
  return theme
}
